export default "__VITE_ASSET__p4$Y3SZV__"